import { render, staticRenderFns } from "./PpSearchPage.vue?vue&type=template&id=0f0074fe&scoped=true&"
import script from "./PpSearchPage.vue?vue&type=script&lang=js&"
export * from "./PpSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0074fe",
  null
  
)

export default component.exports